// AuthService — единая авторизация с Майнкрафтией/Роботехникой/Админкой.
// Используется тот же user-микросервис на minecraftia-school.ru, JWT_SECRET
// общий — токен валиден везде. На startklass только дополняем регистрацию
// данными центра (через свой b2b-микросервис).

import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import {
    API_login,
    API_me,
    API_B2B_register,
    API_B2B_centre_me,
    USER_addres,
} from './API';

const TOKEN_KEY = 'Authorization';


export default class AuthService {

    /** Регистрация B2B-клиента: создаёт Profile + B2BCentre.
     *  consent — обязательное согласие на ПД/оферту/представителя.
     *  captcha — опциональный объект с полями капчи (captchaIdLeft / captchaAnswerLeft / ...),
     *            прокидывается в b2b-микросервис и далее в user-signup где валидируется. */
    static async register({ firstName, email, password, centreName, city, phone, inn, consent, captcha }) {
        try {
            const res = await axios.post(API_B2B_register, {
                firstName, email, password,
                centre_name: centreName, city, phone, inn,
                consent,
                ...(captcha || {}),
            });
            if (res.data?.token) {
                localStorage.setItem(TOKEN_KEY, res.data.token);
            }
            return { ok: true, profile: res.data?.profile, centre: res.data?.centre };
        } catch (e) {
            console.error('AuthService.register error:', e);
            return {
                ok: false,
                message: e.response?.data?.message || 'Ошибка регистрации',
                captchaRequired: e.response?.data?.captcha_required === true,
                status: e.response?.status,
            };
        }
    }

    /** Нужна ли сейчас капча для регистрации.
     *  Адаптивная защита: бэк включает при velocity-burst (> 2 регистраций / 30с).
     *  Идёт напрямую в user-микросервис (не через b2b-прокси). */
    static async isCaptchaRequired() {
        try {
            const r = await axios.get(`${USER_addres}/api/v1/users/captcha/required`);
            return Boolean(r.data?.required);
        } catch {
            return false;
        }
    }

    /** Единый login через b2b-прокси. После него токен валиден на всех 4 сайтах. */
    static async login(email, password) {
        try {
            const res = await axios.post(API_login, { email, password });
            if (res.data?.token) {
                localStorage.setItem(TOKEN_KEY, res.data.token);
                return { ok: true };
            }
            return { ok: false, message: res.data?.message || 'Сервер не вернул токен' };
        } catch (e) {
            return {
                ok: false,
                message: e.response?.data?.message || 'Неверный email или пароль',
            };
        }
    }

    static logout() {
        localStorage.removeItem(TOKEN_KEY);
    }

    static getToken() {
        return localStorage.getItem(TOKEN_KEY);
    }

    static isAuthenticated() {
        const token = this.getToken();
        if (!token) return false;
        try {
            const payload = jwtDecode(token.replace(/^Bearer\s+/i, ''));
            // exp в секундах, Date.now() в миллисекундах
            return payload.exp ? payload.exp * 1000 > Date.now() : true;
        } catch (e) {
            return false;
        }
    }

    /** userId из JWT (для подсветки своих комментариев, ссылок на свой профиль). */
    static getMyUserId() {
        const token = this.getToken();
        if (!token) return null;
        try {
            const payload = jwtDecode(token.replace(/^Bearer\s+/i, ''));
            // identity v2 кладёт идентификатор в sub (UUID); id/user_id —
            // формат прежних токенов, встречается пока они не истекли.
            return payload.sub || payload.id || payload.user_id || payload.userId || null;
        } catch (e) {
            return null;
        }
    }

    /** Загрузить полный профиль через b2b-прокси (user-сервис отдаёт {data: profile}). */
    static async fetchProfile() {
        try {
            const res = await axios.get(API_me, {
                headers: { Authorization: this.getToken() },
            });
            return res.data?.data || res.data || null;
        } catch (e) {
            return null;
        }
    }

    /** Загрузить мой центр (только для b2b_lead/b2b_owner). */
    static async fetchMyCentre() {
        try {
            const res = await axios.get(API_B2B_centre_me, {
                headers: { Authorization: this.getToken() },
            });
            return res.data?.centre;
        } catch (e) {
            return null;
        }
    }

    /**
     * Сохранить реквизиты центра.
     *
     * В отличие от fetchMyCentre ошибку НЕ проглатываем: человек нажал
     * «Сохранить» и должен узнать, если не сохранилось. Молчаливый null тут
     * выглядел бы как успех с потерянными данными.
     */
    static async updateMyCentre(fields) {
        const res = await axios.put(API_B2B_centre_me, fields, {
            headers: { Authorization: this.getToken() },
        });
        return res.data?.centre;
    }
}
